import { jsx as _jsx } from "react/jsx-runtime";
import { ModalDialog, useLocalizeMessage } from 'libs.nucleus';
export const AccessIcfPrompt = ({ isPromptOpen, onConfirm, onCancel, onClose, }) => {
    const translate = useLocalizeMessage();
    return (_jsx(ModalDialog, { title: translate('info.access_icf.title'), body: _jsx("div", { className: 'font-sans m-0 text-sm text-text-secondary', children: _jsx("p", { children: translate('info.access_icf.body') }) }), width: 'lg', actionButtons: [
            {
                label: translate('action.access_icf.online'),
                onClick: onConfirm,
                dataTestId: 'access-icf-confirm',
            },
            {
                label: translate('generic.cancel'),
                onClick: onCancel,
                dataTestId: 'access-icf-cancel',
            },
        ], 
        // Stay mounted while closed. Returning null unmounts the confirm button
        // between ModalDialog's Enter keydown (closeDialog) and the button click.
        isOpen: isPromptOpen, closeDialog: onClose, willCloseOnOutsideClickAndEscapeKeyPress: false }));
};
